<script>
  export let title = "The title";
  export let text = "The text";
  export let dark = false;
  export let alignRight = false;
</script>

<div
  class="info-block"
  class:info-block--dark={dark}
  class:info-block--align-right={alignRight}
>
  <div class="info-block__title">
    {title.toLocaleUpperCase()}
  </div>
  <div class="info-block__separator" />
  <div class="info-block__text">
    {text}
  </div>
</div>

<style lang="scss">
  @import "./assets/styles/variables";
  @import "./assets/styles/animations";

  $text-color-light: black;
  $text-color-dark: white;
  $separator-color-light: white;
  $separator-color-dark: #fbbd91;

  .info-block {
    display: flex;
    flex-direction: column;
    font-family: "Roboto";
    color: $text-color-light;
    padding: 1rem 2rem;

    &__title {
      font-family: "DecathlonBeta";
      font-size: 32px;
      letter-spacing: 2px;
    }

    &__separator {
      animation: flicker 3s infinite step-end;
      background-color: $separator-color-light;
      filter: drop-shadow(0px 0px 8px $separator-color-light)
        drop-shadow(0px 0px 16px $separator-color-light);
      height: 2px;
      margin: 0.75rem 0 1rem 0;
      max-width: 100%;
      width: 12rem;
    }

    &--dark {
      color: $text-color-dark;
    }

    &--align-right {
      align-items: flex-end;
      text-align: right;
    }

    &--dark &__separator {
      animation: flicker 3s 1s infinite step-end;
      background-color: $separator-color-dark;
      filter: drop-shadow(0px 0px 8px $separator-color-dark)
        drop-shadow(0px 0px 16px $separator-color-dark);
    }
  }
</style>
